import { HOST_TYPE } from '@utils/api-helper/host';
import paginateAction from '@utils/paginateAction';
import { combatTypes } from '../constants';

export const fetchContestInfo = (goalUID) => ({
  type: combatTypes.FETCH_CONTEST_INFO,
  endpoint: `api/combat-infos/${goalUID}`,
  method: 'get',
  hostType: HOST_TYPE.CMS,
  goalUID
});

export const fetchContestRating = (goalUID) => ({
  type: combatTypes.FETCH_CONTEST_RATING,
  endpoint: `api/contest-ratings/${goalUID}`,
  method: 'get',
  hostType: HOST_TYPE.CMS,
  goalUID
});

export const fetchMyRating = (goalUID, timePeriod = 30) => ({
  type: combatTypes.FETCH_MY_RATING,
  endpoint: `v1/uplus/contest/my_rating/?goal_uid=${goalUID}&time_period=${timePeriod}`,
  method: 'get',
  goalUID
});

export const fetchUpcomingCombatsInfo = (goalUID) => ({
  type: combatTypes.FETCH_UPCOMING_COMBATS_INFO,
  endpoint: `v1/uplus/contest/upcoming_all/?goal_uid=${goalUID}&limit=5`,
  method: 'get',
  goalUID
});

export const fetchCombatDetails = (combatUID) => ({
  type: combatTypes.FETCH_COMBAT_DETAILS,
  endpoint: `v1/uplus/contest/detail/?contest_uid=${combatUID}`,
  method: 'get',
  combatUID
});

export const fetchContestOnboardingPreferences = (goalUID) => ({
  type: combatTypes.FETCH_CONTEST_ONBOARDING_PREFERENCES,
  endpoint: `v1/user/me/onboarding_preferences/?goal_uid=${goalUID}`,
  method: 'get',
  goalUID
});

export const updateContestOnboardingPreference = ({
  goalUID,
  optionUID,
  selectedClass,
  preferenceType
}) => ({
  type: combatTypes.UPDATE_CONTEST_ONBOARDING_PREFERENCES,
  endpoint: 'v1/user/me/onboarding_preference/',
  method: 'post',
  data: {
    goal_uid: goalUID,
    option_uids: optionUID
  },
  goalUID,
  selectedClass,
  preferenceType
});

export const enrollForContest = ({
  enroll = true,
  inviteCode = '',
  contestUID = ''
}) => ({
  type: combatTypes.ENROLL_FOR_CONTEST,
  endpoint: `v2/uplus/programmes/${contestUID}/save/`,
  method: 'post',
  data: {
    enroll,
    invite_code: inviteCode
  },
  contestUID
});

const getCombatNextAction = (key, resetWithoutEmpty) => (next) => ({
  type: combatTypes.FETCH_PAGINATED_COMBATS,
  endpoint: next,
  method: 'get',
  key,
  resetWithoutEmpty
});

export const fetchCombats = ({
  goalUID,
  preferenceUID,
  state,
  key,
  nextPage,
  resetWithoutEmpty = false
}) => {
  const endpoint = `v1/uplus/contest/all/?goal_uid=${goalUID}&preference=${preferenceUID}&state=${state}&limit=10&offset=0`;

  return paginateAction(
    endpoint,
    getCombatNextAction(key, resetWithoutEmpty),
    'combats',
    key,
    resetWithoutEmpty
  )(nextPage);
};

export const setModalState = (data) => ({
  type: combatTypes.COMBAT_MODAL_TYPE,
  data
});

export const fetchCombatInfo = (combatUID) => ({
  type: combatTypes.FETCH_COMBAT_INFO,
  endpoint: `v1/uplus/contest/detail_v2/?contest_uid=${combatUID}`,
  method: 'get',
  combatUID
});
